<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 14:23:33
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-11 11:52:51
 * @name: 处理方案查看
 * @Description: 处理方案查看
 * @FilePath: \project\src\components\afterSale\dialog-dealScheme-show.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="处理方案查看" width="500px" :visible.sync="show">
    <div class="container">
      <div class="row">
        <font class="label">是否需要用户寄回</font>
        <font class="text">{{
          issueService.getIssueConfigText(
            "need_send_backs",
            plan.need_send_back
          )
        }}</font>
      </div>
      <div class="row">
        <font class="label">寄回方式</font>
        <font class="text">{{
          issueService.getIssueConfigText("send_back_ways", plan.send_back_way)
        }}</font>
      </div>
      <div class="row">
        <font class="label">是否需要费用</font>
        <font class="text">{{
          issueService.getIssueConfigText("need_pays", plan.need_pay)
        }}</font>
      </div>
      <div class="row">
        <font class="label">是否需要品质审批</font>
        <font class="text">{{
          issueService.getIssueConfigText("need_qa_checks", plan.need_qa_check)
        }}</font>
      </div>
      <el-divider></el-divider>
      <div class="row">
        <font class="label">处理方式</font>
        <font class="text">{{
          issueService.getIssueConfigText("resolve_ways", plan.resolve_way)
        }}</font>
      </div>
      <div class="row">
        <font class="label">解决措施</font>
        <font class="text">{{ plan.resolve_plan }}</font>
      </div>
      <div class="row">
        <font class="label">填写用户需寄回物品</font>
        <font class="text">{{ plan.send_back_items }}</font>
      </div>
      <el-divider></el-divider>
      <div class="title">寄件地址</div>
      <div class="address-info">
        <div class="address-row">
          <font class="label">收货人</font>
          <font class="text">{{ send_back_address_name }}</font>
        </div>
        <div class="address-row">
          <font class="label">手机号</font>
          <font class="text">{{ send_back_address_phone }}</font>
        </div>
        <div class="address-row">
          <font class="label">选择地址</font>
          <font class="text">{{ send_back_address_address }}</font>
        </div>
        <div class="address-row">
          <font class="label">详细地址</font>
          <font class="text">{{ send_back_address_detail }}</font>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
export default {
  data() {
    return {
      issueService: new issueService(),
      show: false,
      plan: {},
    };
  },
  computed: {
    send_back_address_name() {
      return this.plan?.send_back_address?.name ?? "";
    },
    send_back_address_phone() {
      return this.plan?.send_back_address?.phone ?? "";
    },
    send_back_address_address() {
      return this.plan?.send_back_address?.address ?? "";
    },
    send_back_address_detail() {
      return this.plan?.send_back_address?.detail ?? "";
    },
  },
  methods: {
    open(plan) {
      this.plan = plan;
      this.show = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    padding: 10px 0;
    @extend .et-flex-normal;
    font-size: $Vars-font-miniContent-size;
    color: $Vars-font-normal-color;
    .label {
      width: calc(#{$Vars-font-miniContent-size} * 10);
      margin-right: 10px;
    }
    .text {
      flex: 1;
    }
  }
  .title {
    font-size: $Vars-font-content-size;
    color: $Vars-font-important-color;
    margin-bottom: 10px;
  }
  .address-info {
    width: 100%;
    font-size: $Vars-font-miniContent-size;
    color: $Vars-font-normal-color;
    @extend .et-flex-column-normal;
    .address-row {
      width: 100%;
      padding: 10px 0;
      border-top: 1px solid $Vars-border-second-color;
      &:first-child {
        border: 0 !important;
      }
      @extend .et-flex-normal;
      .label {
        flex-shrink: 0;
        width: calc(#{$Vars-font-miniContent-size} * 4);
        margin-right: 10px;
      }
      .text {
        flex: 1;
      }
    }
  }
}
</style>